import { applicationFunnelHeaderMilestones } from "./application/term-life-insurance/application-route.constant";
import { quotePillar3aFunnelHeaderMilestones } from "./quote/pillar-3a/quote-route.constant";
import { quoteFunnelHeaderMilestones } from "./quote/term-life-insurance/quote-route.constant";

export const allFunnelHeaderMilestones = [
  ...quoteFunnelHeaderMilestones,
  ...applicationFunnelHeaderMilestones,
];

export const allPillar3aFunnelHeaderMilestones = [
  ...quotePillar3aFunnelHeaderMilestones,
];
